import {memo} from 'react';

import type {SVGProps} from 'react';

export const InitiatePaymentIcon = memo(function InitiatePaymentIcon(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M9.62546 15.2915H12.5838C13.2921 15.2915 13.9171 14.7498 13.9588 14.0832C14.0005 13.3332 13.4171 12.7082 12.6671 12.7082H10.7505C8.25046 12.7082 8.16713 12.2915 6.75046 12.2915C4.79213 12.2915 3.37546 14.0832 2.70879 15.1665C2.41713 15.6248 2.45879 16.2082 2.75046 16.6248L4.50046 18.9998C4.83379 19.4165 5.45879 19.4998 5.83379 19.0832C6.16713 18.7082 6.66713 18.3332 7.45879 18.3332C9.20879 18.3332 10.9588 18.7498 12.6255 18.7498C13.8338 18.7498 14.8755 17.5415 19.6255 13.5832L19.5838 13.6248C20.0838 13.1248 20.0838 12.2915 19.5838 11.7915C19.0838 11.2915 18.4171 11.2915 17.7505 11.7915C17.0838 12.2915 13.4171 15.0415 13.4171 15.0415"
          fill="var(--icon-fill-yellow)"
        />
        <path
          d="M11.958 10.375C14.0291 10.375 15.708 8.69607 15.708 6.625C15.708 4.55393 14.0291 2.875 11.958 2.875C9.88694 2.875 8.20801 4.55393 8.20801 6.625C8.20801 8.69607 9.88694 10.375 11.958 10.375Z"
          fill="var(--icon-fill-yellow)"
        />
        <path
          d="M17.1663 12.7915C17.4997 12.4998 17.833 12.2082 18.208 11.9165L18.1663 11.9582C18.6663 11.4582 18.6663 10.6665 18.1663 10.2082C17.6663 9.70818 17.0413 9.74984 16.4163 10.2082C15.7913 10.6665 12.208 13.3332 12.208 13.3332"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.66664 11.375C2.83331 11.9583 2.24998 12.7917 1.87498 13.4167C1.62498 13.8333 1.62498 14.4167 1.91664 14.8333L3.58331 17.125C3.87498 17.5417 4.54164 17.5833 4.87497 17.2083C5.20831 16.8333 5.70831 16.5 6.45831 16.5C8.16664 16.5 9.83331 16.9167 11.4583 16.9167C12.375 16.9167 13.1666 16.25 15.5 14.25"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.54199 13.5417H11.3753C12.042 13.5417 12.667 13.0417 12.7087 12.375C12.7503 11.6667 12.167 11.0417 11.4587 11.0417H9.62533C7.20866 11.0417 7.16699 10.625 5.75033 10.625C5.70866 10.625 5.70866 10.625 5.66699 10.625"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.29199 5.00016C7.29199 3.04183 8.87533 1.4585 10.8337 1.4585C11.5003 1.4585 12.1253 1.62516 12.667 1.9585"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.2087 3.9165C14.3337 4.24984 14.3753 4.62484 14.3753 4.99984C14.3753 6.95817 12.792 8.5415 10.8337 8.5415C9.70866 8.5415 8.70866 7.99984 8.04199 7.20817"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0421 6.66683H10.5421C10.1254 6.66683 9.75042 6.4585 9.62542 6.25016C9.50042 6.0835 9.54208 5.87516 9.70875 5.75016C9.87541 5.62516 10.0837 5.66683 10.1671 5.8335C10.2087 5.87516 10.3337 5.9585 10.5004 5.9585H11.0004C11.1671 5.9585 11.3337 5.8335 11.3337 5.62516C11.3337 5.41683 11.1671 5.29183 11.0004 5.29183H10.6254C10.0421 5.29183 9.58375 4.8335 9.58375 4.29183C9.58375 3.75016 10.1254 3.3335 10.6671 3.3335H11.0421C11.5837 3.3335 11.8754 3.7085 11.8754 3.79183C11.9587 3.9585 11.9171 4.16683 11.7504 4.25016C11.5837 4.3335 11.3754 4.29183 11.2921 4.12516C11.2921 4.12516 11.2087 4.00016 11.0421 4.00016H10.6671C10.5004 4.00016 10.3337 4.12516 10.3337 4.3335C10.3337 4.54183 10.5004 4.66683 10.6671 4.66683H11.0421C11.6254 4.66683 12.0837 5.12516 12.0837 5.66683C12.0837 6.2085 11.6254 6.66683 11.0421 6.66683Z"
          fill="var(--icon-stroke-yellow)"
        />
        <path
          d="M10.833 3.125V3.625"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={0.833333}
          strokeLinecap="round"
        />
        <path
          d="M10.833 6.875V6.375"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={0.833333}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
});
